import { render, staticRenderFns } from "./discovery-illustration.vue?vue&type=template&id=9a09f9a4&scoped=true&"
import script from "./discovery-illustration.vue?vue&type=script&lang=js&"
export * from "./discovery-illustration.vue?vue&type=script&lang=js&"
import style0 from "./discovery-illustration.vue?vue&type=style&index=0&id=9a09f9a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a09f9a4",
  null
  
)

export default component.exports